function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { CvsdkError, ErrorSeverity } from '../../../error';
import { TimelineItemType } from './timeline';
export var TimelineError = /*#__PURE__*/ function(CvsdkError) {
    "use strict";
    _inherits(TimelineError, CvsdkError);
    function TimelineError(error, currentTimelineItemType) {
        _class_call_check(this, TimelineError);
        var _this;
        _this = _call_super(this, TimelineError, [
            error.code,
            error.message,
            ErrorSeverity.Warning,
            error.cause,
            error.category,
            error.reason,
            error.parameters,
            error.originalSeverity
        ]);
        Object.setPrototypeOf(_this, TimelineError.prototype);
        // restore prototype chain
        _this.name = 'TimelineError';
        if (currentTimelineItemType === TimelineItemType.MainContent) {
            _this.message = "".concat(error.message, ", during Main Content - Ending Timeline");
            _this.code = "".concat(error.code, ".MAIN_CONTENT");
            _this.severity = ErrorSeverity.Fatal;
        } else if (currentTimelineItemType === TimelineItemType.Advert) {
            _this.message = "".concat(error.message, ", during Advert - Starting next Item in Timeline");
            _this.code = "".concat(error.code, ".ADVERT");
            _this.severity = ErrorSeverity.Warning;
        }
        return _this;
    }
    return TimelineError;
}(CvsdkError);

//# sourceMappingURL=timeline-error.js.map